<template>
	<div style="width: 100%;">
		<!-- PC -->
		<div v-if="ifPc == 1">
			<div
				style="margin: 100px 60px 100px 60px;font-weight: bold;font-size: 80px;height: 94px;line-height: 94px;">
				Contact Us
			</div>

			<div style="background-color: #F6F6F6;display: flex;margin: 0px 60px;">

				<div style="width: 600px;height: 600px;">
					<div style="margin:78px 87px 108px 87px;">
						<div style="font-size: 24px;font-weight: bold;">
							Our Offices
						</div>
						<div style="font-size: 20px;line-height: 30px;margin-top: 10px;">
							5813 Wilford Dr, Mckinney, TX 75070
						</div>
						<div style="font-size: 20px;line-height: 30px;">
							2001 Coit Rd #137, Plano, TX 75075
						</div>

						<div style="font-size: 24px;font-weight: bold;margin-top: 100px;">
							Phone
						</div>
						<div style="font-size: 20px;line-height: 30px;margin-top: 10px;">
							800-571-6066
						</div>

						<div style="font-size: 24px;font-weight: bold;margin-top: 100px;">
							Email
						</div>
						<div style="font-size: 20px;line-height: 30px;margin-top: 10px;">
							Info@joblogic-x.com
						</div>

					</div>
				</div>
				<div style="flex: 1;height: 600px;">
					<el-image src="/newImage/contact.png" style="height: 600px;width: 100%;" fit="cover">
					</el-image>
				</div>
			</div>
			<div style="height: 150px;"></div>

		</div>
		<!-- 手机 -->
		<div v-if="ifPc == 2">
			<div
				style="margin: 20px 14px;font-weight: bold;font-size: 18px;height:21px;line-height: 21px;">
				Contact Us
			</div>

			<div style="background-color: #F6F6F6;display: flex;margin: 0px 15px;">

				<div style="width: 137px;height: 137px;">
					<div style="margin:15px 18px 0px 18px;">
						<div style="font-size: 10px;font-weight: bold;">
							Our Offices
						</div>
						<div style="font-size: 6px;line-height: 9px;margin-top: 2px;">
							5813 Wilford Dr, Mckinney, TX 75070
						</div>
						<div style="font-size: 6px;line-height: 9px;">
							2001 Coit Rd #137, Plano, TX 75075
						</div>

						<div style="font-size: 10px;font-weight: bold;margin-top: 12px;">
							Phone
						</div>
						<div style="font-size: 6px;line-height: 9px;margin-top: 2px;">
							800-571-6066
						</div>

						<div style="font-size: 10px;font-weight: bold;margin-top: 12px;">
							Email
						</div>
						<div style="font-size: 6px;line-height: 9px;margin-top: 2px;">
							Info@joblogic-x.com
						</div>

					</div>
				</div>
				<div style="flex: 1;height: 137px;">
					<el-image src="/newImage/contact.png" style="height: 137px;width: 100%;" fit="cover">
					</el-image>
				</div>
			</div>
			<div style="height: 40px;"></div>
		</div>
	</div>
</template>
<script>
	import utils from "../utils/index.js";
	export default {
		name: "App",
		data() {
			return {
				innerHeight: window.innerHeight,
				ifPc: window.innerWidth > window.innerHeight ? 1 : 2 // 默认根据宽高判断 1PC 2手机
			};
		},
		computed: {},
		methods: {
			changePage(page) {
				this.$router.push(page);
			}
		},
		mounted() {}
	};
</script>

<style lang="less">
</style>